import { render, staticRenderFns } from "./GetPhoto.vue?vue&type=template&id=55f963ff&scoped=true&"
import script from "./GetPhoto.vue?vue&type=script&lang=js&"
export * from "./GetPhoto.vue?vue&type=script&lang=js&"
import style0 from "./GetPhoto.vue?vue&type=style&index=0&id=55f963ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f963ff",
  null
  
)

export default component.exports